// extracted by mini-css-extract-plugin
export default {"bannerUrlInput":"shopForm_bannerUrlInput__+Grg3","hint":"shopForm_hint__b3s0N","red":"shopForm_red__jhl2C"};